import React from 'react';
import { Rate as AntdRate, type RateProps as AntdRateProps } from 'antd';
import classNames from 'classnames';
import { Icons } from '@monorepo/icons';
import { IconsNames } from '@monorepo/types';

import style from './rate.module.scss';

type RateProps = AntdRateProps & {
  isSmileIcon?: boolean;
};

export const Rate = ({ isSmileIcon, className, ...props }: RateProps) => {
  return (
    <AntdRate
      {...props}
      className={classNames('the5ers-rate', style['rate'], className)}
      character={
        isSmileIcon ? ({ index = 0 }) => smileIcons[index + 1] : props.character
      }
    />
  );
};

const smileIcons: Record<number, React.JSX.Element> = {
  1: (
    <Icons
      className={style['smileIcon']}
      iconName={IconsNames.SmileRatingOne}
    />
  ),
  2: (
    <Icons
      className={style['smileIcon']}
      iconName={IconsNames.SmileRatingTwo}
    />
  ),
  3: (
    <Icons
      className={style['smileIcon']}
      iconName={IconsNames.SmileRatingThree}
    />
  ),
  4: (
    <Icons
      className={style['smileIcon']}
      iconName={IconsNames.SmileRatingFour}
    />
  ),
  5: (
    <Icons
      className={style['smileIcon']}
      iconName={IconsNames.SmileRatingFive}
    />
  ),
};
